<template>
  <v-container fluid class="pa-0">
    <!-- <view-header title="Trucks" description="Manage the Trucks from this CMS portal."/> -->
    <v-container fluid class="pa-5">
      <generic-data-table 
        :items="entities['truck']" 
        :loading="loading" 
        :headers="truckHeaders" 
        :search="search"
        :show_excel="true"
        :show_print="true"
        :showCardView="showCardView != undefined? showCardView : true"
        entity_name="truck"
        @add="saveEntity(null)"
        @rowClick="row => saveEntity(row)"
        :icon="'mdi-truck'"
      >
      </generic-data-table>
    </v-container>
    <truck-details
      v-model="showEditItem"
      v-if="showEditItem"
      :headers="truckHeaders"
      entity_name="truck"
      title="Trucks"
      :truck="current_entity['truck']"
    >
    </truck-details>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import DataTable from '@/components/DataTable'
import TruckDetails from '@/components/truck/TruckDetails'
import GenericDataTable from '@/components/GenericDataTable'
import TruckHeadersMixin from '@/mixins/truckHeaders'

export default {
  data() {
    return  {
      search: '',
      showEditItem: false
    }
  },
  props: ['showCardView'],
  mixins:[TruckHeadersMixin],
  computed: {
    ...mapState('entities',['current_entity','entities','loading'])
  },
  components: {
    DataTable, TruckDetails, GenericDataTable
  },
  methods: {
    ...mapActions('entities',['getEntities','saveEntity']),
    ...mapState('users',['loggedIn','user']),
    saveEntity(entity) {
        this.showEditItem = true;
        if(entity !== null) this.current_entity['truck'] = entity
    }
  },
  mounted() {
    this.getEntities('truck');
  }
}
</script>